import { RENEW_TOKEN } from '../../constants';
import { createAction } from 'redux-actions';
import { renewTokenRequest } from '../users/authMethods';
import { urlRenewToken } from '../urls';

export const renewToken = createAction(RENEW_TOKEN, (oldToken) =>
  renewTokenRequest(urlRenewToken, oldToken)(),
);
